
import { Product, Group } from "@/lib/types";
import ProductCard from "@/components/product/ProductCard";

interface ProductListProps {
  products: Product[];
  onUpdate: () => void;
  onAddStock: (product: Product) => void;
  onRecordUsage: (product: Product) => void;
  onRecordPastUsage: (product: Product) => void;
  onQuickUsage: (product: Product) => void;
  onDelete: (productId: string) => void;
}

const ProductList = ({
  products,
  onUpdate,
  onAddStock,
  onRecordUsage,
  onRecordPastUsage,
  onQuickUsage,
  onDelete
}: ProductListProps) => {
  if (products.length === 0) {
    return null;
  }

  return (
    <div className="card-grid">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onUpdate={onUpdate}
          onAddStock={() => onAddStock(product)}
          onRecordUsage={() => onRecordUsage(product)}
          onRecordPastUsage={() => onRecordPastUsage(product)}
          onQuickUsage={() => onQuickUsage(product)}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default ProductList;
